<template>
  <div class="body-box marginBox2">
    <el-row class="plan"></el-row>

    <el-form ref="editFormRef" :model="editForm" label-width="140px" style="padding: 20px;background-color: #fff;margin-top: 10px;">
      <el-row class="labelBox">
        <!--球场名称-->
        <el-col :span="8">
          <el-form-item label="球场名称(用户)">
            <span class="colorStatus">{{newContent.courtName}}</span>
          </el-form-item>

          <el-form-item label="球场名称">
            <el-input v-model="editForm.courtName" disabled/>
          </el-form-item>
        </el-col>

        <!--预约人-->
        <el-col :span="8">
          <el-form-item label="预约人(用户)">
            <span class="colorStatus">{{newContent.userName}}</span>
          </el-form-item>


          <el-form-item label="预约人">
            <el-input v-model="editForm.userName"/>
          </el-form-item>
        </el-col>

        <!--预约人电话-->
        <el-col :span="8">
          <el-form-item label="预约人电话(用户)">
            <span class="colorStatus">{{newContent.tel}}</span>
          </el-form-item>


          <el-form-item label="预约人电话">
            <el-input v-model="editForm.tel"/>
          </el-form-item>
        </el-col>

        <!--预约人邮箱-->
        <el-col :span="8">
          <el-form-item label="预约人邮箱(用户)">
            <span class="colorStatus">{{newContent.email}}</span>
          </el-form-item>


          <el-form-item label="预约人邮箱">
            <el-input v-model="editForm.email"/>
          </el-form-item>
        </el-col>

        <!--打球时间-->
        <el-col :span="8">
          <el-form-item label="打球日期(用户)">
            <span class="colorStatus">{{newContent.courtDate | formatDate}}</span>
          </el-form-item>

          <el-form-item label="打球日期">
            <el-date-picker style="width: 100%;" v-model="editForm.courtDate" type="date" value-format="timestamp"></el-date-picker>
          </el-form-item>
        </el-col>

        <!--打球时间-->
        <el-col :span="8">
          <el-form-item label="打球时间起(用户)">
            <span class="colorStatus">{{newContent.courtTime | formatDate('hh:mm:ss')}}</span>
          </el-form-item>

          <el-form-item label="打球时间起">
            <el-time-picker value-format="timestamp" v-model="editForm.courtTime" style="width: 100%;"></el-time-picker>
          </el-form-item>
        </el-col>

        <!--打球时间-->
        <el-col :span="8">
          <el-form-item label="打球时间至(用户)">
            <span class="colorStatus">{{newContent.courtEndTime | formatDate('hh:mm:ss')}}</span>
          </el-form-item>

          <el-form-item label="打球时间至">
            <el-time-picker value-format="timestamp" v-model="editForm.courtEndTime" style="width: 100%;"></el-time-picker>
          </el-form-item>
        </el-col>

        <!--接送车需要-->
        <el-col :span="8">
          <el-form-item label="接送车需要(用户)">
            <span class="colorStatus">{{newContent.enumShuttle === 'YES' ? '是' : '否'}}</span>
          </el-form-item>

          <el-form-item label="接送车需要">
            <el-select v-model="editForm.enumShuttle" clearable placeholder="请选择接送车需要" style="width: 100%">
              <el-option key="YES" label="是" value="YES"></el-option>
              <el-option key="NO" label="否" value="NO"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--送迎车备注-->
        <el-col :span="8">
          <el-form-item label="送迎车备注(用户)">
            <span class="colorStatus">{{newContent.distance}}</span>
          </el-form-item>

          <el-form-item label="送迎车备注">
            <el-input v-model="editForm.distance"/>
          </el-form-item>
        </el-col>

        <!--总金额-->
        <el-col :span="8">
          <!--<el-form-item label="总金额(用户)">
            <span class="colorStatus">{{newContent.cost}}</span>
          </el-form-item>-->


          <el-form-item label="总金额">
            <el-input v-model="editForm.cost"/>
          </el-form-item>
        </el-col>

        <!--确认日期-->
        <el-col :span="8">
          <!--<el-form-item label="确认日期(用户)">
            <span class="colorStatus">{{newContent.confirmDate}}</span>
          </el-form-item>-->


          <el-form-item label="确认日期">
            <el-date-picker style="width: 100%;" v-model="editForm.confirmDate" type="date" value-format="timestamp"></el-date-picker>
          </el-form-item>
        </el-col>

        <!--确认时间-->
        <el-col :span="8">
          <!--<el-form-item label="确认时间(用户)">
            <span class="colorStatus">{{newContent.confirmTime}}</span>
          </el-form-item>-->


          <el-form-item label="确认时间">
            <el-input v-model="editForm.confirmTime"/>
          </el-form-item>
        </el-col>

        <!--备注-->
        <el-col :span="24">
          <el-form-item label="备注(用户)">
            <span class="colorStatus">{{newContent.brief}}</span>
          </el-form-item>


          <el-form-item label="备注">
            <el-input type="textarea" v-model="editForm.brief"/>
          </el-form-item>
        </el-col>

        <!--用户修改的-->
        <el-col :span="24" style="padding: 20px 150px;font-size: 16px">用户上传的打球人</el-col>
        <el-col :span="24" v-for="item in newGroupPerson">
          <el-row>
            <el-col :span="6" v-for="u in item.data" :key="u.id">
              <el-form-item label="打球人">
                <span class="colorStatus">{{u.name}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>

        <!--修改打球人-->
        <el-col :span="24" style="padding: 20px 150px;font-size: 16px">
          <span>打球列表</span>
          <el-button @click="replace" style="margin-left: 20px;">替换用户填写的打球人</el-button>
        </el-col>
        <el-col :span="24" v-for="item in groupPerson" :key="item.type">
          <el-row>
            <el-col :span="6" v-for="u in item.data" :key="u.id">
              <el-form-item label="打球人">
                <span>{{u.name}}</span>
              </el-form-item>
            </el-col>

            <!--<el-col :span="4" class="playPerson">
              <span @click="addPlayPerson" class="el-icon-circle-plus-outline"></span>
              <span v-if="index !== 0" @click="subPlayPerson(index)" class="el-icon-remove-outline"></span>
            </el-col>-->
          </el-row>
        </el-col>
      </el-row>
    </el-form>

    <div class="goBackBox">
      <el-button @click="submitModifyOrder">修改订单</el-button>
      <el-button @click="goBack">返回</el-button>
    </div>
  </div>
</template>

<script>
import { cancelOrdersByOrderId, modifyOrderCourtsById } from '@/api/order/order'

export default {
  name: "modifyDiamondOrder",
  data () {
    return {
      editForm: {},
      groupPerson: [],
      orderId: '',
      newContent: {},
      newGroupPerson: [],
    }
  },

  created() {
    this.orderId = this.$route.query.orderId
    this.initialize()
  },

  methods: {
    //初始化
    initialize() {
      cancelOrdersByOrderId(this.orderId).then(res => {
        this.editForm = JSON.parse(res.data.rawData)
        this.groupPerson = JSON.parse(this.editForm.groupPerson)
        this.newContent = JSON.parse(res.data.content)
        this.newGroupPerson = JSON.parse(this.newContent.groupPerson)
      })
    },

    //返回
    goBack() {
      this.$router.go(-1)
    },

    //替换打球人
    replace() {
      this.groupPerson = this.newGroupPerson
    },

    //提交修改
    submitModifyOrder() {
      let personNum = 0;
      if (this.groupPerson.length > 0) {
        this.groupPerson.forEach((item) => {
          personNum += item.data.length;
        })
      }
      const data = {
        brief: this.editForm.brief,
        confirmDate: this.editForm.confirmDate,
        confirmTime: this.editForm.confirmTime,
        cost: this.editForm.cost,
        courtDate: this.editForm.courtDate,
        courtEndTime: this.editForm.courtEndTime,
        courtTime: this.editForm.courtTime,
        distance: this.editForm.distance,
        email: this.editForm.email,
        enumShuttle: this.editForm.enumShuttle,
        groupPerson: JSON.stringify(this.groupPerson),
        handleStatus: 'PASS',
        personNum: personNum,
        tel: this.editForm.tel,
        userName: this.editForm.userName
      }

      modifyOrderCourtsById(data, this.orderId).then(res => {
        if (res.code === '0') {
          this.$message.success('执行成功!')
          this.goBack()
        }
      })
    }

  }
}
</script>

<style lang="less" scoped>
.playPerson {
  height: 32px;
  line-height: 32px;

  span {
    font-size: 24px;
    vertical-align: middle;
    margin-left: 20px;
  }
}

.colorStatus {
  color: red;
}
</style>
